module.exports = __webpack_public_path__ + "img/monterey-g-series-rectangle-top-angle.d054feb3.png";